module.exports = __webpack_public_path__ + "c2786635435e8487316a17572d3268e2.svg";